/* eslint-disable */

import React, { useState } from "react";
import { useBanners } from "./useBanners";
import { Modal, Spin } from "antd";
import BannerItem from "./BannerItem";
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import BannerForm from "./BannerForm";

const BottomBannersPage = () => {
  const {
    banners = [],
    isLoading,
    updatePositions,
    deleteBanner,
    create,
    update,
  } = useBanners();

  const [showModal, setShowModal] = useState(false);
  const [selectedBanner, setBanner] = useState();

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  function handleDragEnd(event) {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = banners.findIndex(({ id }) => id === active.id);
      const newIndex = banners.findIndex(({ id }) => id === over.id);

      updatePositions(arrayMove(banners, oldIndex, newIndex));
    }
  }

  const onSubmit = async (dto) => {
    if (selectedBanner) {
      update(selectedBanner.id, dto);
    } else {
      create(dto);
    }
  };

  return (
    <>
      <Spin spinning={isLoading}>
        <div className="page-header">
          <h2 className="page-header-title">Bottom Banners</h2>
        </div>

        <section className="tw-flex tw-flex-col tw-gap-8 tw-w-full tw-items-center">
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={banners}
              strategy={verticalListSortingStrategy}
            >
              {banners?.map((banner) => (
                <BannerItem
                  key={banner.id}
                  data={banner}
                  onDelete={() => deleteBanner(banner.id)}
                  onSelect={() => {
                    setBanner(banner);
                    setShowModal(true);
                  }}
                />
              ))}
            </SortableContext>
          </DndContext>
          <button
            className="tw-border-primary tw-rounded-xl tw-border-dashed tw-text-primary tw-max-w-[700px] tw-w-full tw-h-[100px] tw-cursor-pointer"
            onClick={() => setShowModal(true)}
          >
            <span style={{ fontSize: 32 }}>+</span>
          </button>
        </section>
      </Spin>

      <Modal
        visible={showModal}
        onCancel={() => {
          setShowModal(false);
          setBanner(null);
        }}
        footer={null}
      >
        <BannerForm
          data={selectedBanner}
          onSubmit={onSubmit}
          onFinish={() => setShowModal(false)}
        />
      </Modal>
    </>
  );
};

export default BottomBannersPage;
